define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/heading/AttributeController",
	"csi/xml"
], function(array,declare,AttributeController,xml) {

	return declare(AttributeController, {
		_toWriterAttribute: function(/*String*/id, /*String*/type) {
			// summary: enable expression and evaluate
			var	node = this.getNode();
			var	cn = this.m_writer.changeNode(this.m_urlNode);
			
			cn.restoreAttributeExp(id);
			
			array.forEach(this.m_action.heading.m_subheadings, function(sh) {
				if (!sh.m_path && xml.nodeAttributeHasFlag(node, sh.m_id, xml.ATTR_FLAG_DISABLE_EXPRESSION)) {
					cn.restoreAttributeExp(sh.m_id);
				}
			});

			// notify that attribute expression was restored
			this._notifyOfChange(cn, node, id, true, false);
		}
	});
});